export default __webpack_public_path__ + "static/media/B03.ec8b0a50.png";